export const getCompleteEmailSharing = (state) => state.emailSharing;
